import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found-404',
    templateUrl: './not-found-404.component.html',
    styleUrls: ['./not-found-404.component.css']
})

export class NotFound404Component {
}
